export function helmetIcon () {

  let svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  let pathOne = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  let pathTwo = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  svg.setAttributeNS( null, 'viewBox', '0 0 32 32');
  pathOne.setAttributeNS( null, 'd', 'm 12.926,13.569 c 0,-0.961 -0.779,-1.74 -1.74,-1.74 -0.96,0 -1.74,0.779 -1.74,1.74 0,0.96 0.779,1.739 1.74,1.739 0.961,10e-4 1.74,-0.778 1.74,-1.739 l 0,0 z');
  pathTwo.setAttributeNS( null, 'd', 'M 26.977,9.864 C 24.027,3.194 16.228,0.178 9.558,3.128 5.838,4.774 3.083,8.042 2.092,11.987 c 0.112,3.613 0.827,7.182 2.116,10.56 7.119,3.92 14.919,6.449 22.984,7.453 1.027,-1.952 1.775,-4.037 2.225,-6.196 -4.256,-0.492 -8.484,-1.198 -12.669,-2.116 -1.827,-0.401 -3.483,-1.361 -4.74,-2.747 L 8.965,15.584 C 8.151,14.686 7.957,13.386 8.474,12.29 c 0.707,-1.499 2.494,-2.141 3.993,-1.434 l 3.077,1.451 c 0.387,0.183 0.809,0.28 1.236,0.286 4.02,0.058 8.038,-0.19 12.02,-0.74 1.178,3.703 1.422,7.639 0.713,11.459 -0.331,-0.039 -0.663,-0.078 -0.994,-0.119 0.846,-4.497 0.309,-9.144 -1.542,-13.329 z');

  svg.appendChild( pathOne );
  svg.appendChild( pathTwo );

  return svg;

}
